import Api from '../http.service';

// get all money unit

export const getAll = () =>
  Api.GET({
    url: `money_unit`,
  });
